import React, {useContext, useEffect, useState} from 'react';
import {Col, Form, InputGroup, Row} from "react-bootstrap";
import FormHookInput from "../../air/airBooking/components/formHookInput";
import SearchSelect from "../../../components/searchSelect";
import {Controller, useController, useWatch} from "react-hook-form";
import _ from 'lodash'
import FormHookSelect from "../../air/airBooking/components/formHookSelect";
import ApiSelect from "../../base/components/forms/apiSelect";
import CurrencyPicker from "../../base/components/forms/currencySelector";
import CustomDatePicker from "../../base/components/forms/customDatePicker";
import ModalCityForm from "./ModalCityForm";
import { v4 as uuidv4 } from 'uuid';
import UploadDocuments from "./uploadDocuments";
import ParseInput from "../../air/airBooking/components/parseInput";
import axios from "../../../helpers/axios";
import sayError from "../../../helpers/sayError";
import moment from "moment";
import Button from "react-bootstrap/Button";
import numberFormat from "../../../helpers/numberFormat";
import serviceContext from "./serviceContext";
import * as uuid from "uuid";
import LogsModal from "./LogsModal";
import {TripItemCreateRoute, TripItemEditRoute} from "../../routesConstants";
import {LinkOff} from "@material-ui/icons";
import {Link} from "react-router-dom";

const fieldsList= [
  {label:'Маршрут', inputName:'route', type:'text', defaultValue:''},
  {label:'Отель', inputName:'hotel', type:'text', defaultValue:''},
  {label:'Тип питания', inputName:'typeMeal', type:'text', defaultValue:''},
  {label:'Тип номера', inputName:'typeRoom', type:'text', defaultValue:''},
  {label:'Количество ночей', inputName:'nights', type:'number', defaultValue:0},
  {label:'Комментарий услуги', inputName:'comment', type:'text', defaultValue:''},
  {label:'Туристический пакет', inputName:'touristPack', type:'text', defaultValue:''},
  {label:'Экскурсия', inputName:'excursion', type:'text', defaultValue:''},
  {label:'Перевозчик', inputName:'carrier', type:'carrier'},
  {label:'БСО', inputName:'ticket', type:'text', defaultValue:''},
  {label:'Количество дней', inputName:'days', type:'number', defaultValue:0},
  {label:'Тип визы', inputName:'typeVisa', type:'select', options:['Гостевая', 'Служебная', 'Деловая', 'Туристическая']},
  {label:'Кратность визы', inputName:'multiplicityVisa', type:'select', options:['Однократная', 'Двухкратная', 'Трехкратная', 'Многократная']},
  {label:'Страховая сумма', inputName:'insuranceSum', type:'number', defaultValue:0},
  {label:'Вид прочих', inputName:'typeOther', type:'text', defaultValue:''},
  {label:'Номенклатура', inputName:'nomenclature', type:'text', defaultValue:''},
  {label:'Город', inputName:'city', type:'city'},
  {label:'Срочность', inputName:'urgency', type:'select', options:['Сроная', 'НеСрочная']}
]

const ServiceItem = ({prefix,
                       types,
                       formController,
                       serv,
                       deleteService,
                       copy,
                       countries,
                       edit,
                       update,
                       suppliers,
                       fromParser,
                       setTempValue,
                       nameCount}) => {
  const {control, register, watch, formState: {errors}, getValues, setValue, setError, clearErrors} = formController
  const [currencyType,setCurrencyType] = useState(process.env.REACT_APP_DEFAULT_CURRENCY !== serv.currency)
  const [codeEditable, setCodeEditable] = useState(!serv.id)
  const {serviceItems,setServiceItems} = useContext(serviceContext)

  const {
    field: { onChange: typeOnChange, value: typeValue }
  } = useController({
    name: `${prefix}.type`,
    rules: { required: true },
    control,
    defaultValue: ''
  });
  const {
    field: { onChange: supplierOnChange, value: supplierValue }
  } = useController({
    name: `${prefix}.supplier`,
    control,
    rules: { required: true },
    defaultValue: ''
  });
  const {
    field: { onChange: countryOnChange, value: countryValue }
  } = useController({
    name: `${prefix}.country`,
    control,
    rules: { required: true },
    defaultValue: ''
  });

  const getParam = (name) =>{
    return +_.get(getValues(), `${prefix}.${name}`) || 0

  }
  const changeContext = () =>{
    const array = serviceItems.slice()
    array[prefix.slice(13,-1)] = _.get(getValues(), `${prefix}`)
    setServiceItems(array)
  }

  useEffect(() => {
    if(getParam('summCurrency')!==0 || (getParam('summCurrency')===0  && getParam('summKZT')!==0)){
      let sumKzt=+(getParam('summCurrency')*getParam('exchangeRate')).toFixed(2)
      if(getValues().issuedWithoutDocs) sumKzt = Math.ceil(sumKzt)
      setValue(`${prefix}.summKZT`, sumKzt)
      // setServiceItems(changeContext())
    }
  }, [watch([`${prefix}.summCurrency`,`${prefix}.exchangeRate`,`${prefix}.krsKayar`,`${prefix}.commission`,`${prefix}.quantity`])]);

  const calculateTotal = () =>{
    return (getParam('summKZT')+getParam('krsKayar')+getParam('commission'))*getParam('quantity')
  }
  useEffect(() => {
    const type =_.get(getValues(), `${prefix}.type`)
    if(_.get(getValues(), `${prefix}.canceled`) && edit && type=== process.env.REACT_APP_SERVICE_TYPE_CHECKIN){
      // setValue(`${prefix}.type`, process.env.REACT_APP_SERVICE_TYPE_PENALTY)
      typeOnChange(process.env.REACT_APP_SERVICE_TYPE_PENALTY)
    }
  }, [useWatch({control,name:`${prefix}.canceled`})]);

  useEffect(() => {
    const nights = _.get(getValues(), `${prefix}.optionalFields.nights`)
    const startDate =_.get(getValues(), `${prefix}.startDate`)
    const endDate = _.get(getValues(), `${prefix}.endDate`)
    const type =_.get(getValues(), `${prefix}.type`)
    if(startDate && endDate && type && !edit && nights >= 0){
      const diffDate = moment.duration(moment(endDate,'DD.MM.YYYY').diff(moment(startDate,'DD.MM.YYYY'))).asDays()
      setValue(`${prefix}.optionalFields.nights`, diffDate)
    }
    // setServiceItems(changeContext())
  }, [useWatch({control,name:[`${prefix}.startDate`,`${prefix}.endDate`,`${prefix}.type`]})]);

  useEffect(() => {
    if(
      _.get(getValues(), `${prefix}.supplier`) === process.env.REACT_APP_DEFAULT_WITHOUTDOC_SUPPLIER
      && !getValues().issuedWithoutDocs &&!edit){
      setValue(`issuedWithoutDocs`, true)
    }
  }, [useWatch({control,name:`${prefix}.supplier`})]);
  useEffect(() => {
    const currencyId = _.get(getValues(), `${prefix}.currency`)
    const exchangeRateNow = _.get(getValues(), `${prefix}.exchangeRate`)
    if(currencyId && currencyId !== serv.currency){
      if(process.env.REACT_APP_DEFAULT_CURRENCY !== currencyId){
        if(!fromParser){
          axios.post('/api/currencies/exchangeRateByDate',{
            currencyId,
            date: edit ?getValues().issueDate.slice(0,10): getValues().issueDate})
            .then(({data})=>{
              setValue(`${prefix}.exchangeRate`,data.exchangeRate)
            })
            .catch(sayError)
        }
        setCurrencyType(true)
      } else if(process.env.REACT_APP_DEFAULT_CURRENCY === currencyId){
        if(exchangeRateNow !== 1){
          setValue(`${prefix}.exchangeRate`,1)
        }
        setCurrencyType(false)
      }
    }
    delete serv.copied
  }, [useWatch({control, name:[`${prefix}.currency`,'issueDate']})]);
  useEffect(() => {
    const typeId = _.get(getValues(), `${prefix}.type`)
    const idIn1C = _.get(getValues(), `${prefix}.idInOneC`)
    if((idIn1C === '' || idIn1C.length === 13) && typeId && !serv.id){
      const codeType = _.find(types,{id: typeId})?.code
      let random = Math.floor(Math.random()*10000)
      const newId = moment().format('YYMMDD')+'-'+codeType+ String(random).padStart(4, '0')
      setValue(`${prefix}.idInOneC`,newId)
      changeContext()
    }
  }, [useWatch({control, name:[`${prefix}.type`]})]);

  if(!countries){
    return 'loading...'
  }

  const renderOptionalInputs = () =>{
    if(typeValue === ''){
      return <p>
        Пожалуйста выберите тип услуги для генерации дополнительных полей
      </p>
    } else{
      const neededInfo = _.find(types, {id:typeValue})
      if(neededInfo.fields.length === 0){
        return <p>Дополнительных полей не требуется</p>
      }else{
        return neededInfo.fields.map((label,index)=>{
          const input = _.find(fieldsList, {label})
          if(input.type === 'select'){
            return <FormHookSelect
              label={input.label}
              register={register(`${prefix}.optionalFields.${input.inputName}`)}
              errors={errors}
            >
              {input.options.map((o,i)=> {
                return <option key={i} value={o}>{o}</option>
              })}
            </FormHookSelect>
          }else if(input.type === 'city'){
            return <div className={'d-flex align-items-center justify-content-between'}><Controller
              control={control}
              render={({ field: { onChange, onBlur, value:cityValue } }) => (
                <ApiSelect
                  value={cityValue}
                  label={'Город'}
                  url={"/api/locations/cities/searchInput"}
                  style={{width:'90%'}}
                  allInfo
                  cb={newVal => {
                    onChange(newVal.value)
                    if(_.get(getValues(),`${prefix}.country`)!== newVal.country){
                      setValue(`${prefix}.country`, newVal.country)
                  }}
                }
                />
              )}
              name={`${prefix}.optionalFields.city`}
            />
              <ModalCityForm changeValue={(id)=>{setValue(`${prefix}.optionalFields.city`,id)}}/>
            </div>
          }else if(input.type === 'carrier'){
            return <Controller
              control={control}
              render={({ field: { onChange, onBlur, value } }) => (
                <ApiSelect
                  value={value}
                  label={'Перевозчик(Контрагент)'}
                  url={"/api/counterparty/searchInput"}
                  queryBase={process.env.REACT_APP_COUNTERPARTIES_FROM_NEWBASE === "true" ? {fromNewBase: true} : {}}
                  cb={newVal => onChange(newVal)}
                />
              )}
              name={`${prefix}.optionalFields.carrier`}
            />
          } else {
            return <div className={'mb-3'} key={index}>
              <FormHookInput
                register={register(`${prefix}.optionalFields.${input.inputName}`,{onBlur:(e)=>{
                    changeContext()
                  }})}
                label={input.label}
                type={input.type}
                defaultValue={input.defaultValue}
                errors={errors}
              />
            </div>
          }
        })
      }
    }
  }

  const onBlur = (e,name) =>{
    if(e.target.value === ""){
      e.target.value = 0
      setValue(`${prefix}.${name}`, 0)
    }
  }
  const onFocus = (e) =>{
    if(e.target.value === "0"){
      e.target.value = ""
    }
  }
  const howPercentage = (e) =>{
    console.log(e.target.value)
    if(e.target.value && e.target.value !== 0){
      let summCurrency = getParam('summCurrency')
      let exchangeRate = getParam('exchangeRate')
      let commission = (summCurrency*e.target.value/100)*exchangeRate
      summCurrency = summCurrency*(100-e.target.value)/100
      setValue(`${prefix}.summCurrency`, summCurrency)
      setValue(`${prefix}.commission`, Math.ceil(commission/10)*10)
      // let commission = (summCurrency*e.target.value/100)*exchangeRate
      // summCurrency = Math.ceil(summCurrency*(100-e.target.value)/100)
      // setValue(`${prefix}.summCurrency`, summCurrency)
      // setValue(`${prefix}.commission`,Math.ceil(commission/10)*10 )
      changeContext()
      e.target.value = 0
    }
  }

  const createElement = () =>{
    localStorage.setItem('servForElement', serv.id)
    window.open(TripItemCreateRoute,'_blank')
  }
  const renderCreateElButton = () => {
    if(serv && serv.id && !serv.tripItem && process.env.REACT_APP_SERVICE_TYPE_CHECKIN === serv.type) {
    return <div onClick={createElement} className={'text-primary'} style={{cursor: 'pointer'}}>
      Создать элемент
    </div>}else if(serv && serv.tripItem){
      return  <Link to={TripItemEditRoute+serv.tripItem} target={'_blank'}>Элемент с этой услугой создан</Link>
    }
  }

  return (
    <>
      <Row>
        <Col xs={8}>
          <Row className={'mb-3'}>
            <Col >
              <FormHookSelect
                defaultValue={supplierValue}
                register={register(`${prefix}.supplier`, { required: true })}
                errors={errors}
                label={'Поставщик'}
              >
                {suppliers?.map((u,index)=>{
                  if(!u.isHidden || u.value === supplierValue){
                    return <option key={index} value={u.value}>{u.label}</option>
                  }
                 return
                })}
              </FormHookSelect>
            </Col>
            <Col>
              <FormHookInput
                register={register(`${prefix}.idInOneC`,{
                  required:true,
                  validate: {
                  noSpaces: (value) =>
                  !value.includes(' ') || 'Замените пробелы',

                  noLeadingZeros: (value) =>
                  !/^0+/.test(value) || 'Код не может начинаться с нуля'
                },
                  onBlur:()=>{changeContext()},
                })}
                disabled={!!serv.id && !codeEditable}
                label={<>
                  Индивидуальный код
                  {serv.id && <i
                    className={`fa ${codeEditable ? 'fa-unlock' : 'fa-lock'} ml-2`}
                    style={{cursor: 'pointer'}}
                    onClick={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      setCodeEditable(value => !value)
                    }}
                  />}
                </>}
                showErrorText
                errors={errors}
              />
            </Col>
            <Col xs={3}>
              <FormHookInput
                register={register(`${prefix}.quantity`, {required: true,
                  onBlur:()=>{changeContext()},
                })}
                label={'Кол-во услуг'}
                type={'number'}
                errors={errors}
              />
            </Col>
          </Row>
          <Row className={'mb-3'}>
            <Col>
              <FormHookInput
                onChange={e => {
                  e.target.value = ("" + e.target.value).toUpperCase();
                }}
                inputstyle={{"text-transform": "uppercase"}}
                register={register(`${prefix}.mainPax`, {
                  required: true,
                  onBlur:()=>{changeContext()},
                  onChange: e => {
                    e.target.value = ("" + e.target.value).toUpperCase();
                  }
                })}
                label={'Основной пассажир'}
                errors={errors}
              />
            </Col>
            <Col xs={2}>
              <FormHookInput
                register={register(`${prefix}.totalpaxes`, {required: true,})}
                label={'Всего ч.'}
                type={'number'}
                errors={errors}
              />
            </Col>
          </Row>
          <Row className={'mb-3'}>
            <Col>
              <CustomDatePicker formController={formController}
                                value={serv.startDate}
                                name={`${prefix}.startDate`}
                                rules={{required: true}}
                                cb={(date)=>{
                                  const endDate = _.get(getValues(), `${prefix}.endDate`)
                                  if(endDate && moment(date).isAfter(moment(endDate, 'DD.MM.YYYY'))){
                                    setValue(`${prefix}.endDate`, moment(date).format('DD.MM.YYYY'))
                                    clearErrors(`${prefix}.endDate`)
                                  }
                                }}
                                label={'Дата начала'}/>
            </Col>
            <Col>
              <CustomDatePicker formController={formController}
                                value={serv.endDate}
                                name={`${prefix}.endDate`}
                                rules={{required: true,
                                validate:{
                                  isBefore: (value)=>{
                                    const startDate = _.get(getValues(), `${prefix}.startDate`)
                                    return moment(value, 'DD.MM.YYYY').isSameOrAfter(moment(startDate,'DD.MM.YYYY')) || "Не раньше старта"
                                  }
                                }}}
                                label={'Дата окончания'}/>
            </Col>
            <Col xs={5}>
              <SearchSelect
                onChange={countryOnChange}
                label={'Страна'}
                hasError={_.get(errors, `${prefix}.country`)}
                defaultValue={countryValue}
                array={countries}/>
            </Col>
          </Row>
          <Row className={'mb-3'}>
            <Col xs={4}>
              <CurrencyPicker
                value={serv.currency}
                key={serv.id}
                formController={formController}
                label={'Валюта'}
                name={`${prefix}.currency`}
                errors={errors}
              />
            </Col>
            <Col xs={3}>
              <FormHookInput
                register={register(`${prefix}.exchangeRate`, {required: true,})}
                label={'Курс'}
                step={"0.01"}
                type={'number'}
                errors={errors}
                onWheel={(e) => e.target.blur()}
              />
            </Col>
            <Col >
              <FormHookInput
                register={register(`${prefix}.summCurrency`, {required: true,
                  onBlur: e=> {
                    onBlur(e,'summCurrency')
                    changeContext()
                  },
                })}
                label={'Сумма Вал.'}
                step={"0.01"}
                onFocus={onFocus}
                type={'number'}
                errors={errors}
                onWheel={(e) => e.target.blur()}
              />
            </Col>
            <Col xs={2}>
              <div style={{position: 'relative'}}>
                <label className={'absolutLabel'}>%</label>
                <Form.Control
                  defaultValue={0}
                  onFocus={onFocus}
                  onBlur={howPercentage}
                  onKeyDown={(e)=>{
                    if(e.key === "Enter"){
                      e.target.blur();
                    }
                  }}
                  className={'form-control'}
                  type={'number'}
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            </Col>
          </Row>
          <Row className={'mb-3'}>
            <Col>
              <FormHookInput
                register={register(`${prefix}.summKZT`, {required: true,})}
                label={'СуммаKZT'}
                type={'number'}
                step={"0.01"}
                errors={errors}
                disabled

              />
            </Col>
            <Col>
              <FormHookInput
                register={register(`${prefix}.commission`, {required: true,
                  onBlur: e=> {
                    onBlur(e,'commission')
                    changeContext()
                  },
                })}
                label={'Комиссия'}
                type={'number'}
                step={"0.01"}
                onWheel={(e) => e.target.blur()}
                onFocus={onFocus}
                errors={errors}
              />
            </Col>
            <Col>
                <FormHookInput
                  register={register(`${prefix}.krsKayar`,{onBlur: e=> {
                      onBlur(e,'krsKayar')
                      changeContext()
                    }})}
                  label={'КРС Kayar'}
                  type={'number'}
                  step={"0.01"}
                  onFocus={onFocus}
                  errors={errors}
                  onWheel={(e) => e.target.blur()}
                />
            </Col>

          </Row>
          <Row>
            <Col xs={8}>
              <FormHookInput
                register={register(`${prefix}.discription`)}
                label={'Комментарий'}
                errors={errors}
              />
            </Col>
            <Col>
              <div style={{position: 'relative'}}>
                <label className={'absolutLabel'}>Калькулятор КРС</label>
                <InputGroup className="mb-3">
                  <Form.Control
                    onBlur={(e) => {
                      let krs = e.target.value - _.get(getValues(), `${prefix}.summKZT`)
                      if(currencyType){
                        krs = (e.target.value*_.get(getValues(), `${prefix}.exchangeRate`)- _.get(getValues(), `${prefix}.summKZT`)).toFixed(2)
                      }
                      setValue(`${prefix}.commission`, krs)
                      e.target.value = ''
                      changeContext()
                    }}
                    disabled={_.get(getValues(), `${prefix}.summKZT`) === 0}
                    type="number"
                  />
                  <Button variant="outline-secondary" onClick={()=>setCurrencyType(!currencyType)} disabled={_.get(getValues(), `${prefix}.summKZT`) === 0}>
                    {currencyType ? 'В' : 'Тг'}
                  </Button>
                </InputGroup>

              </div>
            </Col>
          </Row>
          <UploadDocuments cb={(v) => {
            setValue(`${prefix}.documents`, v)
          }}
                           docs={serv.documents}
                           folder={'serviceDocs'}/>
          <div className={'d-flex justify-content-between'}>
            <Form.Label className={'d-flex align-items-center gap-2'}>
              <input
                defaultChecked={serv.canceled}
                {...register(`${prefix}.canceled`)}
                type={"checkbox"}
              />{" "}
              <div className={'text-danger'}>Отменен</div>
            </Form.Label>
            {getValues().issuedWithoutDocs && <Form.Label className={'d-flex align-items-center gap-2'}>
              <input
                defaultChecked={serv.dontSearchInTable}
                {...register(`${prefix}.dontSearchInTable`)}
                type={"checkbox"}
              />{" "}
              <div>Не искать в Google</div>
            </Form.Label>}
          </div>

          <div className={'d-flex justify-content-between align-items-center'}>
            <h5 className={'mt-3'}>Итоговая стоимость: {numberFormat(calculateTotal())} KZT</h5>
            {_.get(getValues(), `${prefix}.exchangeRate`) > 1 &&
              <div>Комиссия в валюте: {numberFormat(Math.round(_.get(getValues(), `${prefix}.commission`)/_.get(getValues(), `${prefix}.exchangeRate`)))}</div>}

          </div>
        </Col>
        <Col>
          <Button onClick={() => setTempValue()}
                  disabled={!nameCount}
                  className={'w-100'}
                  variant={'outline-primary'}>Заполнить шаблон</Button>
          {!nameCount && <div >Выберите покупателя</div>}
          {!edit && <div className={'mt-3'}><ParseInput url={'api/touristServices/rateHawk/parse'}
                                                        keyValue={'text'}
                                                        setter={update}
                                                        placeholder={'Парс тур услуги'}/></div> }
          <div className={'mb-3 mt-3'}>
          <SearchSelect label={'Тип услуги'}
                          onChange={(e) => {
                            typeOnChange(e)
                            changeContext()
                            setValue(`${prefix}.forVisa`, _.find(types, {id:e})?.name === "Бронь для визы")
                          }}
                          hasError={_.get(errors, `${prefix}.type`)}
                          defaultValue={typeValue}
                          errors={errors}
                          array={types.map(t => ({label: t.name, value: t.id}))}/>
          </div>

          {renderOptionalInputs()}
          {_.get(getValues(), `${prefix}.canceled`) && <Row className={'mt-3'}>
            <FormHookInput
              register={register(`${prefix}.amountSell`,)}
              label={'Стоимость закупа KZT'}
              type={'number'}
              step={"0.01"}
              disabled
              errors={errors}
            />
          </Row>}

        </Col>
      </Row>
      <div className={'d-flex justify-content-end align-items-center gap-2'}>
        <LogsModal id={serv.id} suppliers={suppliers} model={'serviceItem'}/>
        <div onClick={copy} className={'text-primary'} style={{cursor: 'pointer'}}>
          Скопировать услугу <i className="fa fa-clone ml-2"/>
        </div>
        <div className={'text-danger'}
             onClick={() => deleteService()}
             style={{cursor: 'pointer', textAlign: 'end', width: 'max-content'}}>
          Удалить услугу <i className={"fa fa-trash"}/>
        </div>
      </div>
      <div className={'d-flex justify-content-end align-items-center gap-2'}>
        {renderCreateElButton()}
      </div>
      {serv.info && serv.info.map((info, i) => {
        return <div className={'text-danger mt-2'} key={i}>{info}</div>
      })}
    </>

  );
};

export default ServiceItem;
